import createSvgIcon from "./utils/create_icon"

const ArrowRightLarge = createSvgIcon(<path d="M14.293 18.707a1 1 0 0 1 0-1.414L18.586 13H3a1 1 0 1 1 0-2h15.586l-4.293-4.293a1 1 0 0 1 1.414-1.414l6 6a1 1 0 0 1 0 1.414l-6 6a1 1 0 0 1-1.414 0z" clipRule="evenodd" fill="currentColor" fillRule="evenodd" />, "ArrowRightLarge")
export default ArrowRightLarge
